import { ParkingSessions } from 'cpfr-common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { fetchParkingSessions } from './ParkingSessionsSlice';
import { ParkingSessionsDataSelector } from './ParkingSessionsDataSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';

export function useParkingSessions(): AbstractDataState<ParkingSessions, DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchParkingSessions, ParkingSessionsDataSelector);
}
